!function ($) {

	//event hook example
	//
	//$('.mk-checkboxscale').on('selected.mk-checkboxscale', function (checkbox, values) {
		//console.info(checkbox.value);
		//console.info(values);
	//});

	function Checkboxscale($container) {
	
		this.$container = $($container);
		this.bind();
	}

	Checkboxscale.prototype = {

		$container: null,

		bind: function () {

			var me = this;
			this.$container.on(
				'click.mk-checkboxscale', 'input[type=checkbox]',
				 function (e) {
					me.check(e);
			});
		},

		set: function (nameOrValue) {

			var $checkboxes = this.$container.find('input:checkbox'),
				$checkbox = $checkboxes.filter('[name=' + nameOrValue + ']');

			if (!$checkbox.length) {
				$checkbox = $checkboxes.filter('[value=' + nameOrValue + ']');
			}

			$checkbox.prop('checked', true);
			
			var event = jQuery.Event('click.mk-checkboxscale');
				event.target = $checkbox[0];

			this.$container.trigger(event);
		},

		reset: function () {

			this.$container.find('input:checkbox').each(function () {
				this.checked = false;
			});

			this.$container.trigger('selected.mk-checkboxscale',
				[null, [/* no values */], [/* no selected elements */]]);
		},

		check: function (e) {

			var $cb = $(e.target),
				$prev = $cb.prevAll('input'),
				$next = $cb.nextAll('input'),
				checked = true,
				values  = [];

			if ($($prev[0]).prop('checked') != true && $cb.prop('checked') != true) {
				checked = false;
			}

			$cb.prop('checked', checked);
			$prev.prop('checked', false);
			$next.prop('checked', true);

			if (checked) {
				values.push($cb.val());
			}

			$next.each(function () {
				values.push(this.value);
			});

			//trigger event hook
			//hands you back a bunch of dope stuff
			this.$container.trigger('selected.mk-checkboxscale',
				[e.target, values, $next]);
		}
	};

	$.FED = $.FED || {};
	$.FED.Checkboxscale = Checkboxscale;

	$.fn.mkCheckboxscale = function () {
		this.each(function () {
			var $el = $(this);
			$el.data('mk-checkboxscale', $el.data('mk-checkboxscale') || new Checkboxscale($el));
		});
	};

	$(function () {
		$('.mk-checkboxscale').mkCheckboxscale();

		$(document).on('loaded', function (event) {
			$(event.target)
				.find('.mk-checkboxscale')
				.each(function (i, ui) {
					$(ui).mkCheckboxscale();
				});
		});
	});

}(window.jQuery);